import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(() =>
  createStyles({
    error: {
      color: "red",
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    root: {
      margin: 0,
    },
  })
);

type TextFieldOutlinedProps = {
  name: string;
  value?: string | number;
  type: string;
  label: string;
  onChange?: (value: string) => void;
  inputRef?: React.Ref<any> | ((instance: any) => void);
  small?: boolean;
  InputProps?: any;
  errors?: any;
  required?: boolean;
  autoFocus?: boolean;
  disabled?: boolean;
  onFocus?: (event: any) => void;
  registration?: any;
};

const TextFieldOutlined = ({
  name,
  type,
  label,
  onChange,
  value,
  inputRef,
  InputProps,
  small,
  errors,
  required,
  autoFocus,
  disabled,
  onFocus,
  registration,
}: TextFieldOutlinedProps) => {
  const classes = useStyles();
  const {
    ref: rhfRef,
    onChange: rhfOnChange,
    onBlur: rhfOnBlur,
    name: rhfName,
  } = registration || {};
  return (
    <>
      <TextField
        className={classes.root}
        variant="outlined"
        margin="normal"
        required={required}
        fullWidth
        value={value}
        type={type}
        inputProps={InputProps}
        id={name}
        label={label}
        inputRef={(e) => {
          if (rhfRef) rhfRef(e);
          if (inputRef) {
            if (typeof inputRef === "function") inputRef(e);
            else (inputRef as any).current = e;
          }
        }}
        name={rhfName || name}
        autoComplete={rhfName || name}
        onBlur={rhfOnBlur}
        onChange={(e) => {
          if (rhfOnChange) rhfOnChange(e);
          if (onChange) onChange(e.target.value);
        }}
        autoFocus={autoFocus}
        onFocus={onFocus}
        size={small ? "small" : "medium"}
        disabled={onChange ? disabled : true}
      />
      {errors && <p className={classes.error}>{errors}</p>}
    </>
  );
};

export default TextFieldOutlined;
